export const CONFIRM_PASSWORD_ERROR = 'CONFIRM_PASSWORD_ERROR'
export const setConfirmPasswordErrorAction = (message: string) => {
  return {
    type: 'CONFIRM_PASSWORD_ERROR',
    payload: message,
  }
}

export const EMAIL_ERROR = 'EMAIL_ERROR'
export const setEmailErrorAction = (message: string) => {
  return {
    type: 'EMAIL_ERROR',
    payload: message,
  }
}

export const PASSWORD_ERROR = 'PASSWORD_ERROR'
export const setPasswordErrorAction = (message: string) => {
  return {
    type: 'PASSWORD_ERROR',
    payload: message,
  }
}

export const STRIPE_ERROR = 'STRIPE_ERROR'
export const setStripeErrorAction = (message: string) => {
  return {
    type: 'STRIPE_ERROR',
    payload: message,
  }
}

export const INIT_ERROR = 'INIT_ERROR'
export const initErrorAction = () => {
  return {
    type: 'INIT_ERROR',
    payload: null,
  }
}
